export default {
  leastDrawn: 'Le moins tiré',
  mostDrawn: 'Le plus tiré',
  leastPlayed: 'Le moins joué',
  mostPlayed: 'Le plus joué',
  drawFrom: 'Tirage à partir de',
  h: 'h', // heure abrégée
  startingIn: 'Commence dans',
  waitingForDrawnFrom: 'En attente du tirage de',
  displayingDrawFrom: 'Affichage du tirage à partir de',
  lotteryDraw: 'Tirage de loterie',
  eventId: 'ID de l’événement',
  bettingShortcuts: 'Raccourcis de paris',
  draw: 'Tirage',
  next5Events: 'Affichage des {value} prochains',
  events: 'Événements',
  schedule: 'Programme',
  next: 'Suivant',
  event: 'Événement',
  later: 'Plus tard',
  statistics: 'Statistiques',
  lastnRounds: 'Derniers {value} tours',
  bettingOffer: 'Offre de paris',
  notDisplayed: 'Non affiché',
  latestResults: 'Derniers résultats',
  drawnAt: 'Tiré à {value}',
  additionalBetting: 'Paris supplémentaires',
  drawSumEvenOdd: 'Somme du tirage Pair ou Impair',
  drawSumTotal: 'Somme totale du tirage',
  drawSumRange: 'Plage de la somme du tirage',
  waitingForDrawNo: 'En attente du tirage n°{value}',
  nextDraw: 'Prochain tirage',
  waitingForDraw: 'En attente du tirage',
  drawCompleted: 'Tirage terminé',
  drawDisplayTemporarilyNotAvailable: 'Affichage du tirage temporairement indisponible',
  connectionError: 'Erreur de connexion !',
  reconnecting: 'Reconnexion...',
  number: 'Numéro',
  headerNumberDescriptionUp: 'Événement',
  headerNumberDescriptionDown: 'Numéro',
};
